import { setTableButtons } from '@/utils/getbuttons.js'
const task = {
  pageTabs: [
    {
      label: '审批整改',
      theme: 'task',
      step: 'approvalList',
      stepLabel: '审批整改列表',
      checkFun: 'taskNotice/getApprovalList'
    },
    {
      label: '预警消息',
      theme: 'task',
      step: 'warningList',
      stepLabel: '预警消息列表',
      checkFun: 'taskNotice/getWarningList'
    },
    {
      label: '通知公告',
      theme: 'task',
      step: 'messageList',
      stepLabel: '通知公告列表',
      checkFun: 'taskNotice/getInboxNoticeList'
    }
  ],
  approval: {
    name: 'approval',
    theme: '审批整改',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'dialogForm'],
    getListFun: 'taskNotice/getApprovalList',
    rowButtons: setTableButtons(['去办理']),
    queryParams: {
      queryName: ''
    },
    selectData: [
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '内容'
      }
    ],
    rowData: (params) => {
      return params.state.taskNotice.approvalList.result
    },
    rowTotal: (params) => {
      return params.state.taskNotice.approvalList.totalSize
    },
    columns: [
      {
        prop: 'titleType',
        label: '业务类型',
        minWidth: '160px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line',
        align: 'center'
      },
      {
        prop: 'orgName',
        label: '所属机构',
        minWidth: '160px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line'
      },
      {
        prop: 'content',
        label: '通知信息',
        width: '860px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line',
        align: 'left'
      },
      { prop: 'launchTime', label: '发起时间', width: '' },
      {
        prop: 'taskStatus',
        label: '办理状态',
        width: '100px',
        keepWidth: true,
        tag: [
          { label: '待审核', type: 'warning' },
          { label: '审核通过', type: 'success' },
          { label: '审核拒绝', type: 'danger' },
          { label: '待整改', type: 'danger' },
          { label: '已整改', type: 'warning' }
        ],
        tooltip: (row) => {
          const tip = row && row.statusTip
          return tip ? { tipValue: tip } : null
        }
      },
      {
        label: '操作',
        buttons: setTableButtons(['去办理'])
      }
    ],
    hasPagination: true
  },
  warning: {
    name: 'warning',
    theme: '预警消息',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables'],
    getListFun: 'taskNotice/getWarningList',
    rowButtons: setTableButtons(['去查看']),
    queryParams: {
      query: ''
    },
    selectData: [
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '内容'
      }
    ],
    rowData: (params) => {
      return params.state.taskNotice.warningList.result
    },
    rowTotal: (params) => {
      return params.state.taskNotice.warningList.totalSize
    },
    columns: [
      {
        prop: 'titleType',
        label: '预警类型',
        minWidth: '160px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line',
        align: 'left'
      },
      {
        prop: 'orgName',
        label: '所属机构',
        minWidth: '160px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line'
      },
      {
        prop: 'content',
        label: '预警内容',
        width: '860px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line',
        align: 'left'
      },
      {
        prop: 'launchTime',
        label: '预警时间',
        minWidth: '170px',
        overflow: false,
        overflowWidth: true,
        keepWidth: true
      },
      {
        prop: 'taskStatus',
        label: '状态',
        width: '100px',
        keepWidth: true,
        tag: [
          { label: '待处理', type: 'warning' },
          { label: '已读', type: 'info' },
          { label: '已处理', type: 'success' }
        ]
      },
      {
        label: '操作',
        buttons: setTableButtons(['去查看'])
      }
    ],
    hasPagination: true
  },
  message: {
    name: 'message',
    theme: '通知公告',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables'],
    getListFun: 'taskNotice/getInboxNoticeList',
    rowButtons: setTableButtons(['查看']),
    queryParams: {
      query: ''
    },
    selectData: [
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '标题/内容'
      }
    ],
    rowData: (params) => {
      return params.state.taskNotice.messageList.result
    },
    rowTotal: (params) => {
      return params.state.taskNotice.messageList.totalSize
    },
    columns: [
      { prop: 'titleType', label: '标题', width: '' },
      { prop: 'takasSource', label: '类型', width: '' },
      {
        prop: 'orgName',
        label: '所属机构',
        minWidth: '160px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line'
      },
      {
        prop: 'content',
        label: '内容',
        width: '860px',
        overflow: false,
        overflowWidth: true,
        className: 'multi-line',
        align: 'left'
      },
      { prop: 'launchTime', label: '发布时间', width: '' },
      {
        label: '操作',
        buttons: setTableButtons(['查看'])
      }
    ],
    hasPagination: true
  }
}

export default task
